<div class="qr-page">

  <wr-qr-code-building-header active="tga" [showSections]="true"></wr-qr-code-building-header>

  @if (facilityElements().length > 0) {
    <div class="filter-bar">
      <nb-select
        [(selected)]="value"
        placeholder="Alle"
        size="small"
        [disabled]="isDisabled">
        <nb-option [value]="null">Alle</nb-option>
        @for (fe of facilityElements(); track fe) {
          <nb-option [value]="fe">
            {{ fe | facilityElementTranslation }}
          </nb-option>
        }
      </nb-select>
    </div>
  }

  <div class="tga-list" [nbSpinner]="loading()">

    @if (tgaList()?.length) {
      @for (tga of tgaList(); track tga.id) {
        <button class="tga-item" (click)="goToDetail(tga.id)">

          <div class="tga-color-bar" [style.background]="tga.equipment.color"></div>

          <div class="tga-icon-wrap">
            @if (tga.equipment.icon; as icon) {
              <img [src]="icon.presignedUrl" [alt]="tga.equipment.name" class="tga-icon-img" />
            } @else {
              <nb-icon icon="settings-2-outline" pack="eva"></nb-icon>
            }
          </div>

          <div class="tga-info">
            <span class="tga-name">{{ tga.equipment.name }}</span>
            @if (tga.creatorTenant) {
              <span class="tga-owner">Ersteller: {{ tga.creatorTenant }}</span>
            }
            <span class="tga-qty">{{ tga.quantity }}&thinsp;×</span>
          </div>

          <nb-icon icon="arrow-ios-forward-outline" pack="eva" class="tga-chevron"></nb-icon>
        </button>
      }
    } @else if (!loading()) {
      <div class="empty-state">
        <nb-icon icon="settings-2-outline" pack="eva"></nb-icon>
        <p>Keine TGA-Einträge gefunden</p>
      </div>
    }

  </div>

</div>
